import { createSlice } from '@reduxjs/toolkit'

const companyAuthSlice = createSlice({
  name: 'companyAuth',
  initialState: {
    companyAuth: false,
    token: '',
    loginError: '',
    loginLoading: false,
    companyId: 0,
  },
  reducers: {
    fetchCompanyLogin: (state) => {
      let data = localStorage.getItem('companyAuth')
      let token = localStorage.getItem('companyToken')
      const companyExpirationDate = localStorage.getItem('companyExpirationDate')

      if (!token || !companyExpirationDate || !data) {
        state.companyAuth = false
        state.token = ''
        return
      }

      const now = new Date()
      const expiry = new Date(companyExpirationDate)

      if (now >= expiry) {
        localStorage.removeItem('companyAuth')
        localStorage.removeItem('companyToken')
        localStorage.removeItem('companyExpirationDate')
        state.companyAuth = false
        state.token = ''
        return
      }

      let parsedData = JSON.parse(data)
      state.companyAuth = parsedData
      state.token = token
    },
    companyLogin: (state) => {
      state.loginLoading = true
      state.loginError = ''
    },
    companyLoginSuccess: (state, { payload }) => {
      let data = JSON.stringify(payload?.data)
      state.companyId = payload?.data?.id

      const now = new Date()
      const companyExpirationDate = new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000)

      localStorage.setItem('companyAuth', data)
      localStorage.setItem('companyToken', payload.data.access_token)
      localStorage.setItem('companyExpirationDate', companyExpirationDate.toISOString())

      state.loginLoading = false
      state.companyAuth = payload.data
      state.token = payload.data.access_token
    },
    companyLoginFailed: (state, { payload }) => {
      state.token = ''
      state.loginLoading = false
      state.loginError = payload.message
    },
    companyLogoutFunc: (state) => {
      localStorage.removeItem('companyAuth')
      localStorage.removeItem('companyToken')
      localStorage.removeItem('companyExpirationDate')

      state.companyAuth = false
      state.token = ''
    },
  },
})

export const {
  companyLogoutFunc,
  fetchCompanyLogin,
  companyLogin,
  companyLoginFailed,
  companyLoginSuccess,
} = companyAuthSlice.actions

export default companyAuthSlice.reducer
